
























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'


@Component
export default class SearchComponent extends Vue {

  @Prop({ default: false })
  loading!: boolean

  @Prop({ default: null })
  result!: Object

  @Prop({ default: () => ({}) })
  initialData!: { givenName?: string, surname?: string, certification?: string }

  data: { givenName?: string, surname?: string, certification?: string } = {}

  @Watch('initialData')
  dataChanged(val: any) {
    this.data = val
    if (this.data.givenName && this.data.surname && this.data.certification) {
      this.search()
    }
  }

  mounted() {
    if (this.data.givenName && this.data.surname && this.data.certification) {
      this.search()
    }
  }

  search() {
    this.$emit('search', this.data)
  }

  retry() {
    this.$emit('retry')
  }
}
